/* MARMOT: патърн „Незабравка" 2.0 – двигател „жива среда" (15.07.2026).
   Стойностите са 1:1 от одобрения прототип Nezabravka Pattern 2.dc.html
   (Claude Design) – не се преизмислят. Всяка форма (data-marmot-shape)
   е самостоятелен елемент със собствена дълбочина и пружина:
     цел  = отместване на курсора × 20px × дълбочина
          + скрол прогрес × 80px × (дълбочина − 0.45) × 2   [В2]
     a    = k·(цел − позиция) − c·скорост, dt ≤ 33ms
   Микроциклите в покой са чист CSS (marmot-pattern.css, marmot-nz-*).
   Вариант В2: скрол слоят се изключва с data-marmot-scroll="off" на
   root-а (един флаг в snippets/marmot-hero-pattern.liquid).
   Формите в огледални/завъртени полета (data-marmot-inv на __field)
   получават вектора през обратната матрица – движението остава в
   екранни координати. Vanilla, defer, само transform + rAF.
   Не се инициализира при prefers-reduced-motion и на тъч устройства –
   там патърнът е напълно статичен (= сегашния статичен вид). */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');

  var CURSOR_AMP = 20;      /* px × дълбочина (прототип: cursorAmp) */
  var PARALLAX_STR = 80;    /* px (прототип: parallaxStrength) */

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function initPattern(root) {
    if (root.dataset.marmotPatternInit === '1') return;
    root.dataset.marmotPatternInit = '1';
    if (REDUCED.matches || !FINE.matches) return;

    var hero = root.closest('.marmot-hero') || root.closest('.marmot-catalog__hero') || root.parentElement;
    if (!hero) return;

    var scrollOn = root.dataset.marmotScroll !== 'off';

    var shapes = [];
    root.querySelectorAll('[data-marmot-shape]').forEach(function (el) {
      var field = el.closest('[data-marmot-inv]');
      var inv = null;
      if (field) {
        inv = field.dataset.marmotInv.split(',').map(parseFloat);
        if (inv.length !== 4 || inv.some(isNaN)) inv = null;
      }
      shapes.push({
        el: el,
        depth: parseFloat(el.dataset.marmotDepth) || 0.5,
        k: parseFloat(el.dataset.marmotK) || 44,
        c: parseFloat(el.dataset.marmotC) || 9.2,
        inv: inv,
        px: 0, py: 0, vx: 0, vy: 0
      });
    });
    if (!shapes.length) return;

    /* нормализирано отместване на курсора от центъра на хирото, [-1 … 1] */
    var nx = 0, ny = 0;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      nx = clamp((e.clientX - (r.left + r.width / 2)) / (r.width / 2), -1, 1);
      ny = clamp((e.clientY - (r.top + r.height / 2)) / (r.height / 2), -1, 1);
    });
    hero.addEventListener('mouseleave', function () { nx = 0; ny = 0; });

    var raf = null;
    var last = null;

    function loop(now) {
      if (last === null) last = now;
      var dt = Math.min((now - last) / 1000, 0.033); /* клампнат dt (прототип) */
      last = now;

      /* прогрес на хирото за скрол parallax (В2): [-0.5 … 0.5] */
      var prog = 0;
      if (scrollOn) {
        var r = hero.getBoundingClientRect();
        var vh = window.innerHeight;
        prog = clamp((vh / 2 - (r.top + r.height / 2)) / (r.height + vh), -0.5, 0.5);
      }

      for (var i = 0; i < shapes.length; i++) {
        var s = shapes[i];
        var tx = nx * CURSOR_AMP * s.depth;
        var ty = ny * CURSOR_AMP * s.depth + prog * PARALLAX_STR * (s.depth - 0.45) * 2;
        /* пружина: a = k·(цел − поз) − c·v (стойностите по форма от прототипа) */
        s.vx += (s.k * (tx - s.px) - s.c * s.vx) * dt;
        s.vy += (s.k * (ty - s.py) - s.c * s.vy) * dt;
        s.px += s.vx * dt;
        s.py += s.vy * dt;
        var ox = s.px, oy = s.py;
        if (s.inv) { /* в огледално/завъртяно поле: екранен вектор → локален */
          ox = s.inv[0] * s.px + s.inv[2] * s.py;
          oy = s.inv[1] * s.px + s.inv[3] * s.py;
        }
        s.el.style.transform = 'translate3d(' + ox.toFixed(2) + 'px,' + oy.toFixed(2) + 'px,0)';
      }
      raf = requestAnimationFrame(loop);
    }

    /* Цикълът върви само докато хирото се вижда – извън екрана спира. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (raf === null) { last = null; raf = requestAnimationFrame(loop); }
          } else if (raf !== null) {
            cancelAnimationFrame(raf);
            raf = null;
          }
        });
      }).observe(hero);
    } else {
      raf = requestAnimationFrame(loop);
    }
  }

  function boot() {
    document.querySelectorAll('[data-marmot-pattern]').forEach(initPattern);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: при пренареждане Shopify рендерира секцията наново. */
  document.addEventListener('shopify:section:load', boot);
})();
